"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyEnquiryListItemDtoQueryEnum = exports.MyEnquiryListItemDtoTypeOfEnquiryEnum = exports.MyEnquiryListItemDtoStatusEnum = exports.MyEnquiryListItemDtoInspectionTypeEnum = void 0;
exports.instanceOfMyEnquiryListItemDto = instanceOfMyEnquiryListItemDto;
exports.MyEnquiryListItemDtoFromJSON = MyEnquiryListItemDtoFromJSON;
exports.MyEnquiryListItemDtoFromJSONTyped = MyEnquiryListItemDtoFromJSONTyped;
exports.MyEnquiryListItemDtoToJSON = MyEnquiryListItemDtoToJSON;
exports.MyEnquiryListItemDtoToJSONTyped = MyEnquiryListItemDtoToJSONTyped;
var AssignedAgentDto_1 = require("./AssignedAgentDto");
var EnquiryUserDetailsDto_1 = require("./EnquiryUserDetailsDto");
/**
 * @export
 */
exports.MyEnquiryListItemDtoInspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * @export
 */
exports.MyEnquiryListItemDtoStatusEnum = {
    Open: 'open',
    InProgress: 'in_progress',
    Resolved: 'resolved'
};
/**
 * @export
 */
exports.MyEnquiryListItemDtoTypeOfEnquiryEnum = {
    PropertyLeads: 'Property Leads',
    GeneralQueries: 'General Queries',
    RequestDocuments: 'Request Documents',
    GetValuation: 'Get Valuation',
    BookAnInspection: 'Book an Inspection',
    ListYourProperty: 'List your property'
};
/**
 * @export
 */
exports.MyEnquiryListItemDtoQueryEnum = {
    PropertyListing: 'property_listing',
    Campaign: 'campaign',
    AccountDelete: 'account_delete',
    Other: 'other'
};
/**
 * Check if a given object implements the MyEnquiryListItemDto interface.
 */
function instanceOfMyEnquiryListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('typeOfEnquiry' in value) || value['typeOfEnquiry'] === undefined)
        return false;
    if (!('userDetails' in value) || value['userDetails'] === undefined)
        return false;
    return true;
}
function MyEnquiryListItemDtoFromJSON(json) {
    return MyEnquiryListItemDtoFromJSONTyped(json, false);
}
function MyEnquiryListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'] == null ? undefined : json['enquiryId'],
        'source': json['source'] == null ? undefined : json['source'],
        'propertyTitle': json['propertyTitle'] == null ? undefined : json['propertyTitle'],
        'inspectionType': json['inspectionType'] == null ? undefined : json['inspectionType'],
        'propertyDescription': json['propertyDescription'] == null ? undefined : json['propertyDescription'],
        'address': json['address'] == null ? undefined : json['address'],
        'updatedAt': (new Date(json['updatedAt'])),
        'status': json['status'],
        'typeOfEnquiry': json['typeOfEnquiry'],
        'userDetails': (0, EnquiryUserDetailsDto_1.EnquiryUserDetailsDtoFromJSON)(json['userDetails']),
        'assignedAgent': json['assignedAgent'] == null ? undefined : (0, AssignedAgentDto_1.AssignedAgentDtoFromJSON)(json['assignedAgent']),
        'query': json['query'] == null ? undefined : json['query'],
    };
}
function MyEnquiryListItemDtoToJSON(json) {
    return MyEnquiryListItemDtoToJSONTyped(json, false);
}
function MyEnquiryListItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'source': value['source'],
        'propertyTitle': value['propertyTitle'],
        'inspectionType': value['inspectionType'],
        'propertyDescription': value['propertyDescription'],
        'address': value['address'],
        'updatedAt': value['updatedAt'].toISOString(),
        'status': value['status'],
        'typeOfEnquiry': value['typeOfEnquiry'],
        'userDetails': (0, EnquiryUserDetailsDto_1.EnquiryUserDetailsDtoToJSON)(value['userDetails']),
        'assignedAgent': (0, AssignedAgentDto_1.AssignedAgentDtoToJSON)(value['assignedAgent']),
        'query': value['query'],
    };
}
